import React from 'react'
import { ChevronRight } from 'react-bootstrap-icons'
import {
  US_STATES_LIST,
  US_STATES_EXCLUDED_FROM_MENU
} from '../../../domain/location/constants'
import transformTextToSlug from '../../../utils/transformTextToSlug'
import { getStateToShowOnMenu } from '../../../domain/useCases/getStateToShowOnMenu'

const UnitedStatesMegaMenu = ({ linkData }) => {
  return (
    <div className="flex w-inherit">
      <div className="flex-1">
        <div className="py-4 font-semibold uppercase leading-9 text-gray-800">
          <p>Rehabs by Location</p>
        </div>

        <div className="flex items-center">
          <a
            className="mb-2 flex items-center font-semibold !text-gray-900 hover:!text-gray-1100"
            href="/united-states/"
          >
            United States
            <ChevronRight className="ml-2.5 size-4" />
          </a>
        </div>

        <div className="flex max-h-[423px] max-w-[720px] flex-col flex-wrap pb-6 pr-12">
          {getStateToShowOnMenu(US_STATES_LIST, US_STATES_EXCLUDED_FROM_MENU)
            .sort()
            .map((location, i) => (
              <a
                className="mb-4 min-w-[180px] text-sm leading-[21px]  !text-gray-700 hover:!text-gray-1100"
                href={`/${transformTextToSlug(location)}/`}
                key={i}
              >
                {location}
              </a>
            ))}
        </div>
        <div className="flex items-center">
          <a
            href="/united-states-locations/"
            className="mb-4 flex items-center !text-gray-800 hover:!text-gray-1100"
          >
            All US Rehab Locations
            <ChevronRight className="ml-5 size-4" />
          </a>
        </div>
      </div>
      <div className="h-fit w-[244px] rounded-lg bg-gray-50 px-8 py-4">
        <p className="mb-6 text-xl text-gray-900">Top Destinations</p>
        <div className="flex flex-col items-start gap-4">
          {linkData.items.map((place) => (
            <a
              href={`/${transformTextToSlug(place.name)}/`}
              key={place.name}
              className="flex flex-row items-center"
            >
              <img
                src={place.src}
                loading="lazy"
                className="mr-4 size-12 rounded-lg"
              />
              <p className="font-semibold !text-gray-800 hover:!text-gray-1100">
                {place.name}
              </p>
            </a>
          ))}
          <div>
            <a
              href="/destinations/"
              className="flex flex-row items-center leading-5 !text-gray-800 hover:!text-gray-1100"
            >
              See More Destinations
              <ChevronRight className="ml-5 mt-0.5 size-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UnitedStatesMegaMenu
